import Cleave from 'cleave.js';
$(function () {
    //Adding custom method to jQuery Validate, to validate and test the strings of First and Last Name against our custom RegEx
    jQuery.validator.addMethod('validName', function (value, element) {
        return this.optional(element) || /^([^!{}()_,=@#$%^&*]){1,40}$/.test(value);
    }, "Use only letters");

    //Adding custom method to jQuery Validate, to validate and test the strings of Phone against our custom RegEx
    jQuery.validator.addMethod('validPhone', function (value, element) {
        return this.optional(element) || /\W([0-9+\s]{9,16})\W|^([0-9+\s]{9,16})\W|\W([0-9+\s]{9,16})$|^([0-9+\s]{9,16})$/.test(value);
    }, "Please enter a valid phone");

    //Adding custom method to jQuery Validate, to validate and test the strings of Phone against our custom RegEx
    jQuery.validator.addMethod('validBirthDate', function (value, element) {
        return /^((\s*)|(((((19|[2-9]\d)\d{2})\-(0[13578]|1[02])\-(0[1-9]|[12]\d|3[01]))|(((19|[2-9]\d)\d{2})\-(0[13456789]|1[012])\-(0[1-9]|[12]\d|30))|(((19|[2-9]\d)\d{2})\-02\-(0[1-9]|1\d|2[0-8]))|(((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))\-02\-29))))$/.test(value);
    }, "Please enter a valid birthdate format (e.g. 1980-12-30)");

    // Hooking the sign-up form with the validation class of jQuery Validate. It accepts "rules" and "messages" as arguements. 
    // For more information on how to use them - go to https://jqueryvalidation.org/ and read the documentation.
    let validationOptions = {
        ignore: ".ignore",
        rules: {
            firstName: {
                required: true,
                minlength: 1,
                validName: true
            },
            lastName: {
                required: true,
                minlength: 1,
                validName: true
            },
            email: {
                required: true,
                email: true
            },
            password: {
                required: true,
                minlength: 5
            },
            confirmPassword: {
                required: true,
                minlength: 5,
                equalTo: "#password"
            },
            phone: {
                validPhone: true,
                required: true
            },
            referral: {
                required: "#referalCheck:checked"
            },
            hiddenRecaptcha: {
                required: function () {
                    if (grecaptcha.getResponse() == '') {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        },
        messages: {
            firstName: {
                required: "Please enter your first name",
                minlength: `Your first name must consist of at least 1 characters!`
            },
            lastName: {
                required: "Please enter your last name",
                minlength: `Your last name must consist of at least 1 characters!`
            },
            email: {
                required: "Please enter your e-mail address",
                email: "Please enter a valid e-mail address"
            },
            password: {
                required: "Please enter a valid password",
                minlength: "Your password must be at least 5 characters long"
            },
            confirmPassword: {
                required: "Please enter a valid password",
                minlength: "Your password must be at least 5 characters long",
                equalTo: "Passwords should match"
            },
            phone: {
                required: "Please enter a valid phone"
            },
            hiddenRecaptcha: {
                required: "Please confirm the reCAPTCHA"
            }
        },
        submitHandler: function (form) {
            // do other things for a valid form
            if (window.innerWidth > 767) {
                $('#loader-wrapper').addClass('visible');
            }

            form.submit();
        }
    };

    let birthdate = $("#birth_date");

    if (birthdate.length) {
        new Cleave('#birth_date', {
            date: true,
            delimiter: '-',
            datePattern: ['Y', 'm', 'd']
        });
        validationOptions['rules'] = Object.assign({}, validationOptions['rules'], { 'birth_date': { 'required': true, 'validBirthDate': true } });
        validationOptions['messages'] = Object.assign({}, validationOptions['messages'], { 'birth_date': { 'required': 'Please enter a valid birthdate format (e.g. 1980-12-30)' } });
    }


    $('#sign-up-form').validate(validationOptions);

    var checked = document.getElementById('referalCheck');
    var inputReferral = document.getElementById('referral');

    if (inputReferral !== null && inputReferral.value != "" && checked) {
        checked.checked = true;
    }

    // The functionality for the view password button.    
    var viewPasswordButton = $('.view-password-btn.on-sign-up');

    if (viewPasswordButton.length > 0) {
        viewPasswordButton.on('click', function (event) {
            var element = $(this),
                inputElement = element.parent().find('input[name*="assword"]');
            if (!element.is(':animated') && !element.hasClass('web-accounts-scripts')) {
                if (!element.hasClass('password-visible')) {
                    element.addClass('password-visible');
                    inputElement.attr('type', 'text');
                } else {
                    element.removeClass('password-visible');
                    inputElement.attr('type', 'password');
                }
            }
        });
    }

    // Simple function to map the errors comming from MP with the exact fields
    var DataExceptions = $('.create-account-alert').find('li');

    if (DataExceptions.length > 0) {
        DataExceptions.each(function () {
            var el = $(this),
                errorCode = el.data('error-code');

            var errorMessageSpan = $('label.main').find('.error-message[data-error-' + errorCode + ']'),
                errorMessageContainer = errorMessageSpan.parent();
            if (errorMessageSpan.length > 0) {
                errorMessageContainer.addClass('error-exception');
                errorMessageContainer.append('<label id="' + errorMessageSpan.data('for') + '-error" class="error" for="' + errorMessageSpan.data('for') + '">' + el[0].innerText + '</label>');
            } else {
                const invalidInput = $(`input[data-error-${errorCode}]`);
                invalidInput.addClass('error')
            }
        });

        $(document).on('focus', '.error-exception', function () {
            $(this).removeClass('error-exception');
        });
    }



});